export const firebaseConfig = {
    apiKey: "AIzaSyBI5URiQueZkm1P9UbrU_p2WVZrL-PdOTU",
    authDomain: "plug-app-a1420.firebaseapp.com",
    projectId: "plug-app-a1420",
    storageBucket: "plug-app-a1420.appspot.com",
    messagingSenderId: "632185061085",
    appId: "1:632185061085:web:201b14879a107f194ce534",
    measurementId: "G-1T5DKGX65B"
};